import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { SAVE_HOSTED_BANK_ACCOUNT } from "../graphql/company";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import AccountType from "enums/AccountType";

const useAcceptTerms = (
  accountKey: string,
  clientSecret: string,
  handleCloseAddBank: any,
  type: AccountType,
) => {
  const [saveHostedBankAccount, { loading: savingHostedBankAccount }] =
    useMutation(SAVE_HOSTED_BANK_ACCOUNT);
  const { t } = useTranslation();

  async function handleAcceptTerms() {
    try {
      const stripe = await loadStripe(
        process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string,
        {
          stripeAccount: accountKey,
        },
      );
      const response = await stripe?.confirmUsBankAccountSetup(clientSecret);
      if (response?.setupIntent?.status === "requires_payment_method") {
        toast.error(
          "Confirmation failed. Please try again to complete account setup.",
        );
      } else if (
        response?.setupIntent?.status === "succeeded" ||
        response?.setupIntent?.next_action?.type === "verify_with_microdeposits"
      ) {
        await saveHostedBankAccount({
          variables: {
            accountId: response?.setupIntent?.payment_method,
            type,
          },
        });

        toast.success("Account successfully added!");
      }
      if (response?.error) {
        toast.error(t("SomethingWentWrongDescriptionWithSupport"));
      }
    } catch (error: any) {
      toast.error(t("SomethingWentWrongDescriptionWithSupport"));
    }
    handleCloseAddBank(true);
  }
  return { handleAcceptTerms, savingHostedBankAccount };
};

export default useAcceptTerms;
